import * as React from 'react';
import * as _ from 'lodash';
import * as hash from 'object-hash';
import { connect, Dispatch } from "react-redux";
import { IApplicationState, AppActionCreators, IVoucherSimulationResponse, VoucherSimulationActionCreators, IVoucherSimulationConfigOverride, IVoucherSimulationConfigDefaultsResponse } from "@nkr/store/index";
import { FormControl, Button, FormGroup, ControlLabel, Well, Alert, Row, Col, Form } from 'react-bootstrap';
import { Utility } from '@nkr/services/utility';
import { GridWrapper } from './styles';
import { toast } from 'react-toastify';
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import { ColumnApi, GridApi, GridReadyEvent, ICellRendererParams } from 'ag-grid-community';
import { AdminListWrapper } from '@nkr/views/ticketing/tickets/styles';
import PendingGrowthRateChanges from './pending-growth-rate-changes';
import { growthModels } from './growth-models';
import { IGrowthRate } from './growth-rate';
import { IValueWithValidation } from './value-with-validation';

interface IOwnProps { }

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getConfigDefaults: () => Promise<IVoucherSimulationConfigDefaultsResponse>,
    getSimulationConfigJson: (name: string, numberOfRuns: number, config: IVoucherSimulationConfigOverride) => Promise<any>,
    submitSimulation: (name: string, numberOfRuns: number, config: IVoucherSimulationConfigOverride) => Promise<IVoucherSimulationResponse>
}

type TProps =
    IOwnProps
    & IStateProps
    & IDispatchProps;

interface IState {
    ageLimit: number,

    growthRateRapidGrowthDecline: number[],
    growthRateMostLikely: number[],
    growthRateSlowGrowth: number[],
    growthRateSlowGrowthDecline: number[],
    growthRate: IGrowthRate[],
    eligibilityForTransplant: IValueWithValidation[],
    mortalityRisk: IValueWithValidation[],
    esrdRisk: IValueWithValidation[]
    name: string,
    runCount: string,
    runCountValid: boolean,
    growthVariability: string,
    growthVariabilityValid: boolean,
    selectedGrowthModel: number,
    confirmDiscardChanges: {
        show: boolean,
        selectedGrowthModel: number
    },
    dirty: boolean,
    simulationResultsFileId: string,
    showResults: boolean
}

const initialState: IState = {
    ageLimit: 85,
    growthRateRapidGrowthDecline: [],
    growthRateMostLikely: [],
    growthRateSlowGrowth: [],
    growthRateSlowGrowthDecline: [],
    growthRate: [],
    eligibilityForTransplant: [],
    mortalityRisk: [],
    esrdRisk: [],
    name: '',
    runCount: '10',
    runCountValid: true,
    growthVariability: '',
    growthVariabilityValid: true,
    selectedGrowthModel: 2,
    confirmDiscardChanges: {
        show: false,
        selectedGrowthModel: 0
    },
    dirty: false,
    simulationResultsFileId: '',
    showResults: false
}

class VoucherSimulation extends React.Component<TProps, IState> {
    readonly state = initialState;

    gridApi: GridApi;
    columnApi: ColumnApi;

    gridApiGrowthModel: GridApi;
    columnApiGrowthModel: ColumnApi;

    onGridReadyGrowthModel = (params: GridReadyEvent) => {
        this.gridApiGrowthModel = params.api;
        this.columnApiGrowthModel = params.columnApi;
    }

    onGridReady = (params: GridReadyEvent) => {
        this.gridApi = params.api;
        this.columnApi = params.columnApi;
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Getting default configuration, one moment please...').then(() => {
            this.props.getConfigDefaults().then(response => {
                if (response.data.success) {
                    let { growthVariability, growthRateRapidGrowthDecline, growthRateMostLikely, growthRateSlowGrowth, growthRateSlowGrowthDecline,
                        eligibilityForTransplant, mortalityRisk, esrdRisk } = response.data.results;

                    this.setState({
                        growthVariability: growthVariability.toString(),
                        growthRateRapidGrowthDecline,
                        growthRateMostLikely,
                        growthRateSlowGrowth,
                        growthRateSlowGrowthDecline,

                        growthRate: growthRateMostLikely.map((x, index) => ({ year: index, value: x.toString(), valid: true })),

                        mortalityRisk: mortalityRisk.map(x => ({ value: x.toString(), valid: true })),
                        esrdRisk: esrdRisk.map(x => ({ value: x.toString(), valid: true })),
                        eligibilityForTransplant: eligibilityForTransplant.map(x => ({ value: x.toString(), valid: true })),
                    })
                }

                this.props.hideLoading();
            });
        });
    }

    getGrowthModelData = (selectedGrowthModel: number) => {
        switch (selectedGrowthModel) {
            case 1: return this.state.growthRateRapidGrowthDecline;
            case 2: return this.state.growthRateMostLikely;
            case 3: return this.state.growthRateSlowGrowth;
            case 4: return this.state.growthRateSlowGrowthDecline;
        }
    }

    handleNameChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        this.setState({
            name: e.currentTarget.value
        });
    }

    handleRunCountChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        this.setState({
            runCount: e.currentTarget.value
        });
    }

    handleGrowthVariabilityChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        this.setState({
            growthVariability: e.currentTarget.value
        });
    }

    handleGrowthModelChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        let selectedGrowthModel = parseInt(e.currentTarget.value);

        let currentGrowthRate = this.state.growthRate.map(x => x.value);
        let currentGrowthRateHash = hash(currentGrowthRate);

        let originalGrowthRate = this.getGrowthModelData(this.state.selectedGrowthModel).map(x => x.toString());
        let originalGrowthRateHash = hash(originalGrowthRate);

        let selectedGrowthRate = this.getGrowthModelData(selectedGrowthModel).map(x => x.toString());

        if (currentGrowthRateHash != originalGrowthRateHash) {
            this.setState({
                confirmDiscardChanges: {
                    show: true,
                    selectedGrowthModel
                }
            });
        } else {
            this.setState({
                selectedGrowthModel,
                growthRate: selectedGrowthRate.map((x, index) => ({ year: index, value: x, valid: true })),
            });
        }
    }

    handleGrowthRateChange = (value: string, itemIndex: number) => {
        let growthRate = _.cloneDeep(this.state.growthRate);

        growthRate = growthRate.map((item, index) => {
            if (index == itemIndex) {
                item.value = value;
            }

            return item;
        });

        this.setState({
            growthRate
        });
    }

    handleMortalityRiskChange = (value: string, itemIndex: number) => {
        let mortalityRisk = _.cloneDeep(this.state.mortalityRisk);

        mortalityRisk = mortalityRisk.map((item, index) => {
            if (index == itemIndex) {
                item.value = value;
            }

            return item;
        });

        this.setState({
            mortalityRisk
        });
    }

    handleEsrdRiskChange = (value: string, itemIndex: number) => {
        let esrdRisk = _.cloneDeep(this.state.esrdRisk);

        esrdRisk = esrdRisk.map((item, index) => {
            if (index == itemIndex) {
                item.value = value;
            }

            return item;
        });

        this.setState({
            esrdRisk
        });
    }

    handleTransplantEligibilityChange = (value: string, itemIndex: number) => {
        let eligibilityForTransplant = _.cloneDeep(this.state.eligibilityForTransplant);

        eligibilityForTransplant = eligibilityForTransplant.map((item, index) => {
            if (index == itemIndex) {
                item.value = value;
            }

            return item;
        });

        this.setState({
            eligibilityForTransplant
        });
    }

    handleSubmitConfig = () => {
        let { runCountValid, growthVariabilityValid, growthRate, eligibilityForTransplant, mortalityRisk, esrdRisk } = this.validate();

        this.setState({
            runCountValid,
            growthVariabilityValid,
            growthRate,
            eligibilityForTransplant,
            mortalityRisk,
            esrdRisk,
            dirty: true
        }, () => {
            if (this.isValid()) {
                let { growthVariability, growthRate, eligibilityForTransplant, mortalityRisk, esrdRisk, name, runCount } = this.state;

                let config: IVoucherSimulationConfigOverride = {
                    name,
                    growthVariability: parseFloat(growthVariability),
                    growthRate: growthRate.map(x => parseFloat(x.value)),
                    eligibilityForTransplant: eligibilityForTransplant.map(x => parseFloat(x.value)),
                    mortalityRisk: mortalityRisk.map(x => parseFloat(x.value)),
                    esrdRisk: esrdRisk.map(x => parseFloat(x.value))
                };

                this.props.showLoading('Submitting config, one moment please...').then(() => {
                    this.props.getSimulationConfigJson(name, parseInt(runCount), config).then(response => {
                        this.props.hideLoading();

                        // if (response.data.success) {
                        //console.log(response);
                        // toast.success('Simulation config submitted successfully');
                        // this.setState({
                        //     simulationResults: response.data.results,
                        //     showResults: true
                        // });
                        // }
                    });
                });
            } else {
                this.gridApi.refreshCells({ force: true });
            }
        });
    }

    handleSubmit = () => {
        let { runCountValid, growthVariabilityValid, growthRate, eligibilityForTransplant, mortalityRisk, esrdRisk } = this.validate();

        this.setState({
            runCountValid,
            growthVariabilityValid,
            growthRate,
            eligibilityForTransplant,
            mortalityRisk,
            esrdRisk,
            dirty: true
        }, () => {
            if (this.isValid()) {
                let { growthVariability, growthRate, eligibilityForTransplant, mortalityRisk, esrdRisk, name, runCount } = this.state;

                let config: IVoucherSimulationConfigOverride = {
                    name,
                    growthVariability: parseFloat(growthVariability),
                    growthRate: growthRate.map(x => parseFloat(x.value)),
                    eligibilityForTransplant: eligibilityForTransplant.map(x => parseFloat(x.value)),
                    mortalityRisk: mortalityRisk.map(x => parseFloat(x.value)),
                    esrdRisk: esrdRisk.map(x => parseFloat(x.value))
                };

                this.props.showLoading('Submitting config, one moment please...').then(() => {
                    this.props.submitSimulation(name, parseInt(runCount), config).then(response => {
                        this.props.hideLoading();

                        if (response.data.success) {
                            toast.success('Simulation config submitted successfully');

                            this.setState({
                                simulationResultsFileId: response.data.results,
                                showResults: true
                            });
                        }
                    });
                });
            } else {
                this.gridApi.refreshCells({ force: true });
            }
        });
    }

    handleConfirmDiscardChangesContinue = () => {
        let selectedGrowthModel = this.state.confirmDiscardChanges.selectedGrowthModel;
        let selectedGrowthRate = this.getGrowthModelData(selectedGrowthModel).map(x => x.toString());

        this.setState({
            selectedGrowthModel,
            growthRate: selectedGrowthRate.map((x, index) => ({ year: index, value: x, valid: true })),
            confirmDiscardChanges: {
                show: false,
                selectedGrowthModel: 0
            }
        });
    }

    handleConfirmDiscardChangesCancel = () => {
        this.setState({
            confirmDiscardChanges: {
                show: false,
                selectedGrowthModel: 0
            }
        });
    }

    validate = () => {
        let runCountValid = Utility.isNumber(this.state.runCount);
        let growthVariabilityValid = Utility.isNumber(this.state.growthVariability);

        let growthRate = _.cloneDeep(this.state.growthRate).map(item => {
            item.valid = Utility.isNumber(item.value);
            return item;
        });

        let eligibilityForTransplant = _.cloneDeep(this.state.eligibilityForTransplant).map(item => {
            item.valid = Utility.isNumber(item.value);
            return item;
        });

        let mortalityRisk = _.cloneDeep(this.state.mortalityRisk).map(item => {
            item.valid = Utility.isNumber(item.value);
            return item;
        });

        let esrdRisk = _.cloneDeep(this.state.esrdRisk).map(item => {
            item.valid = Utility.isNumber(item.value);
            return item;
        });

        return {
            runCountValid,
            growthVariabilityValid,
            growthRate,
            eligibilityForTransplant,
            mortalityRisk,
            esrdRisk
        };
    }

    isValid = () => {
        let { runCountValid, growthVariabilityValid, growthRate, eligibilityForTransplant, mortalityRisk, esrdRisk } = this.state;

        let growthRateValid = growthRate.filter(item => item.valid == false).length == 0;
        let eligibilityForTransplantValid = eligibilityForTransplant.filter(item => item.valid == false).length == 0;
        let mortalityRiskValid = mortalityRisk.filter(item => item.valid == false).length == 0;
        let esrdRiskValid = esrdRisk.filter(item => item.valid == false).length == 0;

        return runCountValid && growthVariabilityValid && growthRateValid && eligibilityForTransplantValid && mortalityRiskValid && esrdRiskValid;
    }

    render = () => {
        const ageRange = _.range(0, this.state.ageLimit + 1);

        const selectedGrowthModel = growthModels.find(x => x.id == this.state.selectedGrowthModel);

        const data = ageRange.map(age => {
            let mortalityRisk = this.state.mortalityRisk.length > age ? this.state.mortalityRisk[age] : { value: 0, valid: true };
            let esrdRisk = this.state.esrdRisk.length > age ? this.state.esrdRisk[age] : { value: 0, valid: true };
            let eligibilityForTransplant = this.state.eligibilityForTransplant.length > age ? this.state.eligibilityForTransplant[age] : { value: 0, valid: true };

            return { age, mortalityRisk, esrdRisk, eligibilityForTransplant };
        });

        const isValid = this.isValid();

        return (
            <>
                <div className='container' style={{ paddingBottom: 20 }}>
                    {this.state.dirty && !isValid && (
                        <Alert bsStyle='danger'>
                            The items in red are invalid
                        </Alert>
                    )}

                    {this.state.showResults && this.state.simulationResultsFileId != '' && (
                        <Alert bsStyle='success'>
                            To see the results of the simulation, <a href={'/voucher-simulation-results/' + this.state.simulationResultsFileId} target='_blank'>click here</a>
                        </Alert>
                    )}

                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                        <div style={{ fontSize: 28, fontWeight: 500 }}>VOUCHER SIMULATION CONFIG</div>
                        <div style={{ textAlign: 'center' }}>
                        </div>
                        <div>
                            {/* <Button style={{ marginRight: 5 }} onClick={this.handleSubmitConfig}>Submit Configuration</Button> */}
                            <Button bsStyle='primary' onClick={this.handleSubmit}>Submit &amp; Run Simulation</Button>
                        </div>
                    </div>

                    <Well style={{ paddingTop: 9.5, paddingBottom: 9.5 }}>
                        <div style={{ display: 'flex', marginBottom: 10 }}>
                            <FormGroup style={{ display: 'flex', alignItems: 'center', width: '100%', marginBottom: 0 }}>
                                <ControlLabel style={{ marginRight: 5, marginBottom: 0 }}>Name:</ControlLabel>
                                <FormControl
                                    value={this.state.name}
                                    onChange={this.handleNameChange}
                                />
                            </FormGroup>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <FormGroup style={{ display: 'flex', alignItems: 'center', marginRight: 20, marginBottom: 0 }} validationState={this.state.dirty && !this.state.runCountValid ? 'error' : null}>
                                <ControlLabel style={{ marginRight: 5, marginBottom: 0 }}>Number of Runs:</ControlLabel>
                                <FormControl
                                    style={{ width: 'initial' }}
                                    value={this.state.runCount}
                                    onChange={this.handleRunCountChange}
                                />
                            </FormGroup>

                            <FormGroup style={{ display: 'flex', alignItems: 'center', marginRight: 20, marginBottom: 0 }} validationState={this.state.dirty && !this.state.growthVariabilityValid ? 'error' : null}>
                                <ControlLabel style={{ marginRight: 5, marginBottom: 0 }}>Growth Variability:</ControlLabel>
                                <FormControl
                                    style={{ width: 'initial' }}
                                    value={this.state.growthVariability}
                                    onChange={this.handleGrowthVariabilityChange}
                                />
                            </FormGroup>

                            <FormGroup style={{ display: 'flex', alignItems: 'center', marginBottom: 0 }}>
                                <ControlLabel style={{ marginRight: 5, marginBottom: 0 }}>Growth Model:</ControlLabel>
                                <FormControl
                                    componentClass='select'
                                    style={{ width: 'initial' }}
                                    value={this.state.selectedGrowthModel}
                                    onChange={this.handleGrowthModelChange}
                                >
                                    {growthModels.map(item =>
                                        <option key={'gm-' + item.id} value={item.id}>{item.label}</option>
                                    )}
                                </FormControl>
                            </FormGroup>
                        </div>
                    </Well>

                    <div style={{ display: 'flex' }}>
                        <AdminListWrapper style={{ width: '35%' }}>
                            <div style={{ textAlign: 'center', marginBottom: 5, fontWeight: 550, fontSize: 16 }}>Growth Rates for Model: {selectedGrowthModel.label}</div>
                            <GridWrapper width={'100%'} height={'74vh'} className='ag-theme-bootstrap'>
                                <AgGridReact
                                    rowData={this.state.growthRate}
                                    suppressCellSelection={true}
                                    rowHeight={32}
                                    onGridReady={this.onGridReadyGrowthModel}
                                    // getRowStyle={this.getRowStyle}
                                    // noRowsOverlayComponentFramework={() => <>No tickets found...</>}
                                    onFirstDataRendered={() => {
                                        this.gridApiGrowthModel.sizeColumnsToFit();
                                    }}
                                >
                                    <AgGridColumn
                                        headerName="Year"
                                        headerClass='list-header'
                                        headerComponentFramework={() => <>Year</>}
                                        field="year"
                                        width={80}
                                        cellClass="list-cell"
                                        suppressSizeToFit={true}
                                    />

                                    <AgGridColumn
                                        headerName="Rate"
                                        headerClass='list-header'
                                        headerComponentFramework={() => <>Rate</>}
                                        // field='value'
                                        width={140}
                                        cellClass="list-cell"
                                        cellRendererFramework={(props: ICellRendererParams) => {
                                            let data = props.data as IGrowthRate;

                                            return (
                                                <FormGroup style={{ marginBottom: 0 }} validationState={this.state.dirty && !data.valid ? 'error' : null}>
                                                    <FormControl
                                                        bsSize='sm'
                                                        defaultValue={data.value}
                                                        onBlur={(e: React.FocusEvent<FormControl & HTMLInputElement>) => this.handleGrowthRateChange(e.currentTarget.value, props.data.year)}
                                                    />
                                                </FormGroup>
                                            );
                                        }}
                                    />
                                </AgGridReact>
                            </GridWrapper>
                        </AdminListWrapper>

                        <div style={{ width: 5 }}></div>

                        <AdminListWrapper style={{ width: '65%' }}>
                            <div style={{ textAlign: 'center', marginBottom: 5, fontWeight: 550, fontSize: 16 }}>Probabilities</div>
                            <GridWrapper width={'100%'} height={'74vh'} className='ag-theme-bootstrap'>
                                <AgGridReact
                                    rowData={data}
                                    suppressCellSelection={true}
                                    rowHeight={32}
                                    onGridReady={this.onGridReady}
                                    // getRowStyle={this.getRowStyle}
                                    noRowsOverlayComponentFramework={() => <>No tickets found...</>}
                                    onFirstDataRendered={() => {
                                        this.gridApi.sizeColumnsToFit();
                                    }}
                                >
                                    <AgGridColumn
                                        headerName="Age"
                                        headerClass='list-header'
                                        headerComponentFramework={() => <>Age</>}
                                        field="age"
                                        width={80}
                                        cellClass="list-cell"
                                    />

                                    <AgGridColumn
                                        headerName="Mortality Risk"
                                        headerClass='list-header'
                                        headerComponentFramework={() => <>Mortality Risk</>}
                                        field='mortalityRisk'
                                        width={140}
                                        cellClass="list-cell"
                                        cellRendererFramework={(props: ICellRendererParams) =>
                                            <FormControl
                                                bsSize='sm'
                                                defaultValue={props.value.value}
                                                onBlur={(e: React.FocusEvent<FormControl & HTMLInputElement>) => this.handleMortalityRiskChange(e.currentTarget.value, props.data.age)}
                                            />
                                        }
                                    />

                                    <AgGridColumn
                                        headerName="ESRD Risk"
                                        headerClass='list-header'
                                        headerComponentFramework={() => <>ESRD Risk</>}
                                        field="esrdRisk"
                                        width={140}
                                        cellClass="list-cell"
                                        cellRendererFramework={(props: ICellRendererParams) =>
                                            <FormControl
                                                bsSize='sm'
                                                defaultValue={props.value.value}
                                                onBlur={(e: React.FocusEvent<FormControl & HTMLInputElement>) => this.handleEsrdRiskChange(e.currentTarget.value, props.data.age)}
                                            />
                                        }
                                    />

                                    <AgGridColumn
                                        headerName="Transplant Eligibility"
                                        headerClass='list-header'
                                        headerComponentFramework={() => <>Transplant Eligibility</>}
                                        field="eligibilityForTransplant"
                                        width={140}
                                        cellClass="list-cell"
                                        cellRendererFramework={(props: ICellRendererParams) =>
                                            <FormControl
                                                bsSize='sm'
                                                defaultValue={props.value.value}
                                                onBlur={(e: React.FocusEvent<FormControl & HTMLInputElement>) => this.handleTransplantEligibilityChange(e.currentTarget.value, props.data.age)}
                                            />
                                        }
                                    />
                                </AgGridReact>
                            </GridWrapper>
                        </AdminListWrapper>
                    </div>

                    <div className='text-right' style={{ marginTop: 10 }}>
                        <Button bsStyle='primary' onClick={this.handleSubmit}>Submit &amp; Run Simulation</Button>
                    </div>
                </div>

                <PendingGrowthRateChanges
                    show={this.state.confirmDiscardChanges.show}
                    onContinue={this.handleConfirmDiscardChangesContinue}
                    onCancel={this.handleConfirmDiscardChangesCancel}
                />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getConfigDefaults: () => {
            return dispatch(VoucherSimulationActionCreators.getConfigDefaults());
        },
        getSimulationConfigJson: (name, numberOfRuns, config) => {
            return dispatch(VoucherSimulationActionCreators.getSimulationConfigJson(numberOfRuns, config));
        },
        submitSimulation: (name, numberOfRuns, config) => {
            return dispatch(VoucherSimulationActionCreators.submitSimulation(numberOfRuns, config));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(VoucherSimulation)